import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { GenericComponent } from '../../dataForms/GenericComponent';

export class StandardProductSettings extends React.Component {

    render() {
        return (
            <div className="view">
                <ImageTitle text='Standard Product Settings' />
                <GenericComponent dataObject='standard-product-setting' dataId={this.props.param_0} enableClone={false} />
            </div>
        );
    }
}